import React from 'react'
import closeIcon from '../../../assets/img/close-grey-small-essential.png'
import styled from 'styled-components'

const Delete = ({onDelete}) => (
  <Container image={`url(${closeIcon})`} onClick={onDelete} onKeyDown={onDelete}/>
)

export default Delete

const Container = styled.button`
  height: 40px;
  width: 40px;
  background-color: white;
  border-radius: 50%;
  display: inline-block;
  border: 4px solid lightgrey;
  background-repeat: no-repeat;
  background-position: center;
  position: absolute;
  bottom: -25px;
  left: calc(50% - 20px);
  background-image: ${props => props.image};
  
  :focus {
	 border: 4px solid #FF9900;
  }
`
